/**
 * useResendTimer Hook
 * Manages countdown timer for email resend functionality
 */

import { useState, useEffect, useCallback } from 'react';

interface UseResendTimerReturn {
  canResend: boolean;
  cooldownSeconds: number;
  startCooldown: () => void;
  resetTimer: () => void;
}

export const useResendTimer = (cooldownDuration: number = 60): UseResendTimerReturn => {
  const [cooldownSeconds, setCooldownSeconds] = useState(0);
  const [canResend, setCanResend] = useState(true);

  const startCooldown = useCallback(() => {
    setCooldownSeconds(cooldownDuration);
    setCanResend(false);
  }, [cooldownDuration]);

  const resetTimer = useCallback(() => {
    setCooldownSeconds(0);
    setCanResend(true);
  }, []);

  useEffect(() => {
    if (cooldownSeconds > 0) {
      const timer = setTimeout(() => {
        setCooldownSeconds(prev => prev - 1);
      }, 1000);

      return () => clearTimeout(timer);
    } else if (cooldownSeconds === 0 && !canResend) {
      setCanResend(true);
    }
  }, [cooldownSeconds, canResend]);

  return {
    canResend,
    cooldownSeconds,
    startCooldown,
    resetTimer,
  };
};